import axios from 'axios'
import Qs from 'qs'
import { getRequestParams } from './common'
import router from '../router'
import { Toast } from 'vant'

// let token = getToken()
// const serverUrl = 'https://applet.hongzhuangxian.cn'
// const serverUrl = 'https://h5.aiqianji.com'
// const serverChatUrl = 'https://aichat.umaxing.com'

const serverUrlObj = {
  development: '/api',
  test: 'https://applet.hongzhuangxian.cn',
  production: 'https://set.aiqianji.com',

}

// https://applet.hongzhuangxian.cn/mini/userMemberInfo

const jumpLogin = (urlparams) => {
  const { type = '1' } = getRequestParams(urlparams) || {}
  return Toast({ message: '登录信息已失效，为您自动跳转至登陆页...',
    duration: 3000,
    onClose: () => {
      return router.push({ path: '/login', query: { page: type === '2' ? 'openVip' : 'buyFrequency' } })
    } })
}
// const baseURL = process.env.NODE_ENV == 'development' ? '/api' : serverUrl
const baseURL = serverUrlObj[process.env.NODE_ENV]
console.log(process.env, '-- process.env', 'baseURL', baseURL)
axios.defaults.withCredentials = false
// axios.defaults.headers['Authorization'] = token ? 'h5::' + token : undefined
axios.defaults.headers['Accept'] = '*/*'

axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'// 配置请求头
axios.defaults.baseURL = baseURL

// TOKEN 还需要处理
// http request拦截器 添加一个请求拦截器
axios.interceptors.request.use(function (config) {
  console.log(config, 'config')
  const { params = {}, data } = config
  config.data = Qs.stringify(config.data)
  let token = window.localStorage.getItem('token')
  if (token) {
    // 将token放到请求头发送给服务器,tokenkey放在请求头中
    config.headers.Authorization = 'h5::' + token
  }

  // eslint-disable-next-line eqeqeq
  if (params.page == 1 || params.pn == 0) {
    Toast.loading({
      message: '加载中...',
      forbidClick: true,
    })
  }
  console.log(config, 'config')
  return config
}, function (error) {
  Toast.fail('请求超时')
  // Do something with request error
  return Promise.reject(error)
})

// 添加一个响应拦截器
axios.interceptors.response.use(function (response) {
  console.log(response, '请求》response')
  Toast.clear()
  if (response.data && response.data.code) {
    if (response.data.message === 'token失效' || response.data.message === '请求头中没有token') {
      // 未登录
      Toast.fail('登录信息已失效，请重新登录')
      router.push('/login')
    }

    if (parseInt(response.data.code) === -1) {
      router.push('/login')
      Toast.fail('请求失败')
    }

    const errorStatus = [500, 502]
    if (errorStatus.includes(response.data.code)) {
      return jumpLogin(response.config.data)
    }
  }
  return response.data
}, function (error) {
  console.log(error, '请求》q')
  console.log(error.response, error.response.config, '请求》1')
  const errorStatus = [500, 502]
  if (errorStatus.includes(error.response.status)) {
    return jumpLogin(error.response.config.data)
  }

  Toast.fail('服务器连接失败')
  return Promise.reject(error)
})

// let base = ''

// 通用方法
// export const POST = (url, params) => {
//     return axios.post(`${base}${url}`, params).then(res => res.data)
// }

// export const GET = (url, params) => {
//     return axios.get(`${base}${url}`, { params }).then(res => res.data)
// }

// export const PUT = (url, params) => {
//     return axios.put(`${base}${url}`, params).then(res => res.data)
// }

// export const DELETE = (url, params) => {
//     return axios.delete(`${base}${url}`, { params: params }).then(res => res.data)
// }

// export const PATCH = (url, params) => {
//     return axios.patch(`${base}${url}`, params).then(res => res.data)
// }

export default axios
